module.exports = __webpack_public_path__ + "img/shouyin.d0218202.png";